import { tagAttributeDetail, tagAttributeStore, tagAttributeEdit } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        fieldValue: ''
      },
      addVisible: false,
      saveLoading: false
    };
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  computed: {
    PROPERTY_RULES() {
      return {
        fieldValue: [{
          required: true,
          message: '请输入属性名称',
          trigger: 'blur'
        }, {
          message: '1-30字符',
          max: 30,
          min: 1
        }]
      };
    }
  },
  methods: {
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          console.log(this.$route);
          if (this.$props.isEdit) {
            let obj = {
              tagsId: this.addForm.tagsId,
              class: this.$route.params.tagsClass,
              fieldValue: this.addForm.fieldValue
            };
            await tagAttributeEdit(obj);
          } else {
            let obj = {
              fieldKey: this.$route.params.tagsName,
              class: this.$route.params.tagsClass,
              fieldValue: this.addForm.fieldValue
            };
            await tagAttributeStore(obj);
          }
          this.$emit('save');
          this.closeAddVisible();
        }
      });
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    },
    async getDetail() {
      const res = await tagAttributeDetail({
        tagsId: this.$props.isEdit
      });
      this.addForm.tagsId = res.id;
      this.addForm.fieldValue = res.fieldValue;
    }
  }
};